import React, { useEffect } from "react";
import styles from "./error.module.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import localizedStrings from "../../utils/localize";

function index() {
  
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  return (
    <div id={styles.notfound}>
      <div className={styles.notfound}>
        <div className={styles.notfound404}>
          <h1>404</h1>
        </div>
        <h2>{localizedStrings.general.pagenotfound}</h2>
        <p>
        {localizedStrings.general.pagenotavailable}
          <Link to="/"> {localizedStrings.general.returntohome}</Link>
        </p>
      </div>
    </div>
  );
}

export default index;
